import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchTransporteurs } from 'store/transporteur/transporteurActions';

import DemandeEnlevementValideeDialogContent from './DemandeEnlevementValideeDialogContent';
import withLoader from 'components/Shared/withLoader';

const DemandeEnlevementValideeDialogContentWithLoader = withLoader(DemandeEnlevementValideeDialogContent);

class DemandeEnlevementValideeDialogContentContainer extends React.Component {

    async componentDidMount() {
        await this.props.fetchTransporteurs();
    }

    render() {
        const { transporteurId, isLoading, onChange, action } = this.props;

        return (
            <DemandeEnlevementValideeDialogContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                transporteurId={transporteurId}
            />
        );
    }
}

DemandeEnlevementValideeDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    let isLoading = state.transporteur.transporteurs.isLoading;

    let transporteurs = state.transporteur.transporteurs.items;

    let transporteur = transporteurs.find(x => x.code === 'JOYAU');

    return {
        isLoading: isLoading,
        transporteurId: transporteur ? transporteur.id : '',
    };
};

const mapDispatchToProps = {
    fetchTransporteurs
};

export default connect(mapStateToProps, mapDispatchToProps)(DemandeEnlevementValideeDialogContentContainer);